import axios from 'axios'

export const serverUrl = `${window.location.origin}/`
export const apiUrl = serverUrl + 'api'
export const studentUrl = serverUrl + 'session/'

export const locale = navigator.language

let _serverPollingInterval

if (process.env.NODE_ENV === 'development') {
  _serverPollingInterval = 3 * 1000
} else {
  _serverPollingInterval = 8 * 1000
}

export const serverPollingInterval = _serverPollingInterval

export const NOT_STARTED = 0
export const AWAITING_PAPER = 1
export const PREPARING = 2
export const READY = 3
export const STARTED = 4
export const FINISHED = 5

export const STUDENT_STATUS = [
  'NOT_STARTED',
  'AWAITING_PAPER',
  'PREPARING',
  'READY',
  'STARTED',
  'FINISHED'
]

export const StatusToComponentMap = new Map([
  [NOT_STARTED, 'NotStarted'],
  [AWAITING_PAPER, 'AwaitingPaper'],
  [PREPARING, 'Preparing'],
  [READY, 'Ready'],
  [STARTED, 'Started'],
  [FINISHED, 'Finished'],
])

export const PROCTORING = [
  'online',
  'offline',
  'identification',
  'auto'
]

const setAwnLabels = locale => {
  const labels = {
    en: {
      success: 'Success',
      tip: 'Attention',
      alert: 'Error',
      async: 'Please, wait...'
    },
    ru: {
      success: 'Успешно',
      tip: 'Внимание',
      alert: 'Ошибка',
      async: 'Подождите...'
    }
  }

  if (locale.startsWith('ru')) return labels.ru
  if (locale.startsWith('en')) return labels.en
}

export const awnOptions = {
  maxNotifications: 4,
  durations: {
    success: 8000,
    alert: 0
  },
  minDurations: {
    async: 400
  },
  animationDuration: 100,
  labels: setAwnLabels(locale)
}

export const setServerLanguage = () => axios.request({
  url: apiUrl + '/setlang/',
  method: 'POST',
  data: `language=${locale}`,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken'
})
  .then(() => console.log(`Language set: ${locale}.`))
  .catch(error => console.debug(error))

export const webRTCConfiguration = {
  iceServers: [{
    urls: ['turn:89.208.84.139', 'turn:85.192.34.250'],
    username: 'kurento',
    credential: 'kurento'
  }, {
    urls: ['stun:global.stun.twilio.com:3478', 'stun:stun.l.google.com:19302']
  }]
}
